import {memo} from 'react';

import styled from 'styled-components';

import {BackgroundProps} from '~/shared/components/TenbisCard/type';

import TenbisCardLogo from './assets/tenbisCardLogo.svg?react';

const Background = styled.div<{isActive?: boolean}>`
  position: absolute;
  display: flex;
  justify-content: center;
  padding-top: 15.8%;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  aspect-ratio: 41 / 18;
  background-color: ${({theme, isActive}) => (!isActive ? 'rgba(140, 153, 155, 0.50)' : theme.colors.primary)};
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 83.22%);
  z-index: 1;
`;

const DefaultBackground = ({isActive}: BackgroundProps) => {
  return (
    <Background isActive={isActive}>
      <TenbisCardLogo />
    </Background>
  );
};

export default memo(DefaultBackground);
